
import { Component, Vue } from "vue-property-decorator";
import { TGuide } from "@/models/guide";
import { API_ROUTES } from "@/utils/API";
import { SMApp, SMUser } from "@/store";
import { EMPLOYER_ROLE, EMPLOYEE_ROLE, CANDIDATE_ROLE } from "@/constants/roles";
import { URLS } from "@/constants/url";
import { REmployer } from "@/pages/Layout/views/Employer/REmployer";
import { REmployee } from "@/pages/Layout/views/Employee/REmployee";
import { RCandidate } from "@/pages/Layout/views/Candidate/RCandidate";
import copy from "copy-to-clipboard";

@Component({
  components: {
    ActionButtons: () => import("@/components/ActionContainer/ActionButtons.vue"),
  },
})
export default class GuideTemplate extends Vue {
  guide: TGuide = {} as TGuide;

  loading = false;

  urls = URLS;

  mounted() {
    this.fetchGuide();
  }

  get id(): number {
    return Number(this.$route.params.id ?? 0);
  }

  async fetchGuide() {
    try {
      this.loading = true;

      const { data } = await this.axios.get(API_ROUTES.GUIDE(this.id));

      if (!data) return;

      this.guide = data;

      this.updatePageTitle(this.guide.guide_alias);
    } finally {
      this.loading = false;
    }
  }

  updatePageTitle(guide_alias: string) {
    SMApp.setPageTitle(`${guide_alias}`);
  }

  get isExpert() {
    return SMUser.isExpert;
  }

  label(role: string) {
    return `${role.charAt(0).toUpperCase()}${role.slice(1)}`;
  }

  get roles() {
    if (this.loading) return [];

    return this.guide.role.split(",");
  }

  getRolePath(path: string) {
    return path ? `/#/${path}/` : "/#/";
  }

  getGuideLink(role: string) {
    const basePath = (this.urls as any)[process.env.NODE_ENV as string] ?? "";

    if (!basePath) return "";

    if (role === EMPLOYER_ROLE)
      return `${basePath}${this.getRolePath(REmployer.path)}guide/${this.id}`;

    if (role === EMPLOYEE_ROLE)
      return `${basePath}${this.getRolePath(REmployee.path)}guide/${this.id}`;

    if (role === CANDIDATE_ROLE)
      return `${basePath}${this.getRolePath(RCandidate.path)}guide/${this.id}`;

    return "";
  }

  copyGuideLink(role: string) {
    copy(this.getGuideLink(role));
  }
}
